export const BAZAAR_VOICE = 'bazaarVoice';
export const DEFAULT = 'default';
